import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

/**
 * A reusable container component for comparison charts and data sections.
 *
 * @param {Object} props
 * @param {string} [props.title] - The title of the box
 * @param {React.ReactNode} props.children - The content to render inside the box
 * @param {Object} [props.sx] - Additional SX styles to override defaults
 */
const NRComparisonSBOMBox = ({ title, children, sx = {} }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexBasis: { xs: '100%', md: 'calc(50% - 12px)' },
        flexGrow: 1,
        p: 2,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(0.5),
        backgroundColor: 'background.paper',
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
        ...sx
      }}
    >
      {title && (
        <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 2 }}>
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

NRComparisonSBOMBox.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
  sx: PropTypes.object
};

export default NRComparisonSBOMBox;
